import * as z from "zod";
import { BREAK_CATEGORIES } from "./live";

export const SEALED_FORMATS = [
  "HOBBY_BOX",
  "BLASTER_BOX",
  "HANGER_BOX",
  "MEGA_BOX",
  "CASE",
  "TIN",
  "BOOSTER_BOX",
  "OTHER",
] as const;
export type SealedFormat = (typeof SEALED_FORMATS)[number];

/** A box, case or tin the shop breaks or sells unopened, with its stock summed across lots. */
export const SealedProduct = z.object({
  id: z.string(),
  storeId: z.string(),
  status: z.enum(["ACTIVE", "ARCHIVED"]),
  name: z.string(),
  brand: z.string().nullable(),
  year: z.number().nullable(),
  setName: z.string().nullable(),
  category: z.enum(BREAK_CATEGORIES),
  format: z.enum(SEALED_FORMATS),
  imageUrl: z.string().nullable(),
  /** What one unit is worth, in cents. The break calculator's default. */
  marketValueCents: z.number().nullable(),
  barcode: z.string().nullable(),
  notes: z.string().nullable(),
  /** What the shop paid per unit, from the newest lot that recorded one. */
  costCents: z.number().nullable(),
  onHand: z.number(),
  /** Held by live breaks. */
  reserved: z.number(),
  available: z.number(),
});
export type SealedProduct = z.output<typeof SealedProduct>;

export type SealedProductListFilter = "all" | "in-stock" | "archived";

export interface SealedProductFields {
  brand?: string;
  year?: number;
  setName?: string;
  category?: SealedProduct["category"];
  format?: SealedFormat;
  /** S3 key of an image already uploaded. */
  imageUrl?: string;
  marketValueCents?: number;
  barcode?: string;
  notes?: string;
}

export interface NewSealedProduct extends SealedProductFields {
  name: string;
  /** Units on hand to start with. */
  quantity?: number;
  /** What the shop paid per unit, in cents. */
  costCents?: number;
  locationId?: string;
}

export interface SealedProductPatch extends SealedProductFields {
  name?: string;
}

/** The new total on hand. `costCents` is recorded on a lot the count creates. */
export interface SealedStockUpdate {
  quantity: number;
  kind?: "ADJUSTED" | "SHRINKAGE";
  reason?: string;
  locationId?: string;
  costCents?: number;
}
